import type { ProcessType } from '@frontend/api';
import { Select, type SelectProps } from '@frontend/components';

import { capitalize } from 'utils/stringUtils';

const getProcessName = (
  process: ProcessType | { name: string } = { name: 'Unknown' },
): string => capitalize(process.name);

const sortHandler = (a: ProcessType, b: ProcessType) =>
  getProcessName(a) > getProcessName(b)
    ? 1
    : getProcessName(a) < getProcessName(b)
    ? -1
    : 0;

type ProcessOptions = {
  label: string;
  value: number;
};

const Process = ({
  availableProcesses,
  disabled,
  onChange,
  selectedProcessId,
  ...restProps
}: {
  availableProcesses?: ProcessType[] | null;
  disabled: boolean;
  onChange: (val?: number) => void;
  selectedProcessId?: number;
} & Omit<SelectProps, 'onChange' | 'disabled'>) => {
  if (!availableProcesses) throw new Error('No available processes');

  const options = availableProcesses.sort(sortHandler).map(
    (availableProcess): ProcessOptions => ({
      label: getProcessName(availableProcess),
      value: availableProcess.id,
    }),
  );

  const value = options.find((p) => p.value === selectedProcessId);
  return (
    <Select
      {...restProps}
      disabled={disabled}
      onChange={(value: ProcessOptions) => {
        const val = value === null ? undefined : value.value;
        onChange(val);
      }}
      options={options}
      value={value}
      placeholder="Select Process"
    />
  );
};

export default Process;
